module.exports = __webpack_public_path__ + "img/us-logo-circle.c0aba7b3.png";